import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogClose } from '@angular/material/dialog';
import { NotificationsService } from '@portal-core/notifications/services/notifications.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { MyNotificationListComponent } from '@portal-core/notifications/components/my-notification-list/my-notification-list.component';
import { TaskNotificationListComponent } from '@portal-core/notifications/components/task-notification-list/task-notification-list.component';

export enum AlertCenterDialogMode {
  MyNotifications = 1, // Start at 1 for easy existence checks
  TaskNotifications
}

/** The dialog data for the alert-center card: which notification view to show, and its license/task-board scope. */
export interface AlertCenterDialogCardData {
  dialogMode?: AlertCenterDialogMode;
  licenseId: number;
  taskBoardId?: number;
}

@Component({
    selector: 'mc-alert-center-dialog-card',
    templateUrl: './alert-center-dialog-card.component.html',
    styleUrls: ['./alert-center-dialog-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatToolbar, MatIconButton, MatDialogClose, MatIcon, NgSwitch, NgSwitchCase, MyNotificationListComponent, TaskNotificationListComponent]
})
export class AlertCenterDialogCardComponent implements OnInit {
  public readonly data = inject<AlertCenterDialogCardData>(MAT_DIALOG_DATA);
  private readonly notificationsService = inject(NotificationsService);
  static DialogConfig: MatDialogConfig = {
    width: '50rem',
    height: '85rem',
    panelClass: 'mc-dialog-card-container',
  };

  AlertCenterDialogMode: typeof AlertCenterDialogMode = AlertCenterDialogMode;

  dialogMode: AlertCenterDialogMode;
  licenseId: number;
  taskBoardId: number;
  ngOnInit() {
    this.dialogMode = this.data.dialogMode || AlertCenterDialogMode.MyNotifications;
    this.licenseId = this.data.licenseId;
    this.taskBoardId = this.data.taskBoardId;

    // If viewing my notifications then mark all notifications as read
    if (this.dialogMode === AlertCenterDialogMode.MyNotifications) {
      this.notificationsService.markAllMyNotificationsAsRead$().subscribe();
    }
  }
}
